import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '980839301047199';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: (...args: unknown[]) => void;
  }
}
function loadPixelScript() {
  if (window.fbq) return;
  const n = window.fbq = function (...args: unknown[]) {
    if ((n as any).callMethod) {
      ;
      (n as any).callMethod.apply(n, args);
    } else {
      ;
      (n as any).queue.push(args);
    }
  } as any;
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [] as unknown[];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  s?.parentNode?.insertBefore(t, s);
  window.fbq('init', PIXEL_ID);
}
export function useMetaPixel() {
  useEffect(() => {
    loadPixelScript();
    window.fbq('track', 'PageView');
  }, []);
}
export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Bochornos a Raya - Protocolo de 14 Días',
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
  }
}